// components/ReportCard.js
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { TrendingReportsIcon } from '../../icons';

const ReportCard = ({ icon, title, description, trending, url }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        cursor: 'pointer',
        borderRadius: trending ? '12px' : '0',
        backgroundColor: '#fff',
        border: trending ? 'none' : 'none',
        boxShadow: trending ? '0 4px 20px rgba(0,0,0,0.06)' : 'none',
        '&:hover': {
          boxShadow: trending ? '0 6px 24px rgba(0,0,0,0.08)' : '0 1px 4px rgba(0,0,0,0.06)',
        },
      }}
    >
      {trending && (
        <Box
          sx={{
            display: 'inline-block',
            px: 1.5,
            py: 0.3, display: 'flex', alignItems: 'center',
            fontSize: '11px',
            fontWeight: 500,
            color: '#fff',
            backgroundColor: '#179046',
            borderRadius: '50px',
            alignSelf: 'flex-start',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            top: '-12px',
            mb: 1,
            whiteSpace: 'nowrap',
          }}
        >
          <TrendingReportsIcon width={'14x'} height={'14px'} /> Trending reports
        </Box>
      )}
      <a href={url}>
        <Box>{icon}</Box>
        <Typography fontWeight={600} fontSize="15px">
          {title}
        </Typography>
        <Typography fontSize="13px" color="text.secondary">
          {description}
        </Typography>
      </a>

    </Paper>
  );
};

export default ReportCard;